import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import { TemplateEditorModal } from '@tymely/features';

export const EditPromptIconButton = (props: {
    value: string;
    setValue: (value: string) => void;
    onEdit?: () => void;
    disabled?: boolean;
}) => {
    const [modalOpen, setModalOpen] = useState(false);

    const handleClick = () => {
        props.onEdit?.();
        setModalOpen(true);
    };

    return (
        <>
            <IconButton title="Open editor" onClick={handleClick} size="small" disabled={props.disabled}>
                ✏️
            </IconButton>
            {props.value !== undefined && modalOpen && (
                <TemplateEditorModal
                    open
                    template={props.value}
                    onClose={() => setModalOpen(false)}
                    onSave={props.setValue}
                />
            )}
        </>
    );
};
